import React, { useState } from 'react';
import { Form, Button, Alert, Spinner, InputGroup } from 'react-bootstrap';
import { login } from '../services/api';
import { validateEmail } from '../pages/validation';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import '../styles/Style.css';
import WebNav from "../components/WebNav";

function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loginPasswordError, setLoginPasswordError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    setLoginPasswordError('');

    const emailValidationError = validateEmail(email);
    if (emailValidationError) {
      setEmailError(emailValidationError);
      setIsLoading(false);
      return;
    }

    if (password.length < 6) {
      setPasswordError('Password should be at least 6 characters long.');
      setIsLoading(false);
      return;
    }

    try {
      const data = await login(email, password);
      localStorage.setItem('token', data.token);
      navigate('/');
      window.location.reload();
    } catch (error) {
      setLoginPasswordError('Login failed. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <>

    <div className="d-flex flex-column flex-lg-row vh-100">
      {/* Left Section with Background Image */}
      <div
        className="d-flex flex-column justify-content-center align-items-center text-white  w-100 w-lg-50 px-4 px-md-5"
        style={{
          backgroundImage: 'url(/images/login.png)', // replace with your actual image path
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="text-center">
          <Link to="/">
            <img
              src="/images/white-logo.png"
              alt="Logo"
              style={{ width: 300, marginBottom: 10, cursor: 'pointer' }}
            />
          </Link>
        </div>
      </div>

      {/* Right Section with Login Form */}
      <div className="d-flex flex-column justify-content-center w-100 w-lg-50 px-4 px-md-5">
        <div style={{ maxWidth: '400px', width: '100%', margin: '0 auto' }}>
          <h3 className="fw-bold mb-3">Sign In</h3>
          <p className="text-muted mb-4">Please enter your details</p>

          {loginPasswordError && (
            <Alert variant="danger" dismissible onClose={() => setLoginPasswordError('')}>
              {loginPasswordError}
            </Alert>
          )}

          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address *</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                isInvalid={!!emailError}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (emailError && !validateEmail(e.target.value)) {
                    setEmailError('');
                  }
                }}
              />
              <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formBasicPassword" className="mt-3">
              <Form.Label>Password *</Form.Label>
              <InputGroup>
                <Form.Control
                  type={passwordVisible ? 'text' : 'password'}
                  placeholder="Create a password"
                  value={password}
                  isInvalid={!!passwordError}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPasswordError(
                      e.target.value.length < 6
                        ? 'Password should be at least 6 characters long.'
                        : ''
                    );
                  }}
                />
                <InputGroup.Text onClick={() => setPasswordVisible(!passwordVisible)} style={{ cursor: 'pointer' }}>
                  <FontAwesomeIcon icon={passwordVisible ? faEyeSlash : faEye} />
                </InputGroup.Text>
              </InputGroup>
              <Form.Control.Feedback type="invalid">{passwordError}</Form.Control.Feedback>
            </Form.Group>

            <Button className="w-100 mt-4" variant="primary" onClick={handleLogin} disabled={isLoading}>
              {isLoading ? <Spinner animation="border" size="sm" /> : 'Sign In'}
            </Button>

            <div className="text-center text-muted my-3">Or continue with</div>

            <div className="d-flex justify-content-between gap-2">
              <Button variant="light" className="w-100 border"><i className="fab fa-google"></i> G</Button>
              <Button variant="light" className="w-100 border"><i className="fab fa-apple"></i> </Button>
              <Button variant="light" className="w-100 border"><i className="fab fa-facebook-f"></i> f</Button>
            </div>

            <div className="text-center mt-3">
              Already have an account?{' '}
              <Link to="/register" className="fw-bold text-decoration-none">
                Sign Up
              </Link>
            </div>
          </Form>
        </div>
      </div>
    </div>

    </>
  );
}

export default Login;
